let containerList = [
  {
    isReverse: false,
    title: ['移动支付专家 全能生意帮手'],
    h4: ['帮助中小微商家将生意经营变的更简单'],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/index/fy_index_01.png'
  },
  {
    isReverse: true,
    title: ['主流移动支付全能收'],
    h4: [
      '多种收款方式、多种收款设备可选。记账',
      '对账、语音播报，让您收款超级简单、',
      '方便。'
    ],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/index/fy_index_02.png'
  },
  {
    isReverse: false,
    title: ['促销活动免费享'],
    h4: [
      '享受微信、支付宝等支付源补贴活动，',
      '助您轻松营销，销量大涨。'
    ],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/index/fy_index_03.png'
  },
  {
    isReverse: true,
    title: ['远程管账、管店、管人'],
    h4: [
      '分级账户系统详细统计各品牌、各分店、',
      '各收银员收款数据，清晰记录每一笔账目，',
      '并可根据财务要求定制对账单。'
    ],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/index/fy_index_04.png'
  },
  {
    isReverse: false,
    title: ['在线客服365天免费咨询'],
    h4: [
      '区域服务专员上门服务，020-28185798',
      '电话客服、“付帅”微信公众号在线',
      '客服，7*24小时为您服务。'
    ],
    imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/index/fy_index_05.png'
  }
]

export default containerList



// WEBPACK FOOTER //
// ./src/assets/conf/index.js